import clsx from "clsx";

export function Inner({ className, ...props }) {
  return <div className={clsx("mx-auto max-w-7xl", className)} {...props} />;
}
